import { render, staticRenderFns } from "./Oasis.vue?vue&type=template&id=f241c388&scoped=true&"
import script from "./Oasis.vue?vue&type=script&lang=js&"
export * from "./Oasis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f241c388",
  null
  
)

export default component.exports